// Utility to convert avatarDecoration keys into CSS border styles
export const getAvatarDecorationBorder = (decoration, sizePx) => {
  // sizePx (number) is the avatar height in pixels; use it to compute a
  // proportional border thickness so rings look consistent at different sizes.
  if (!decoration || typeof decoration !== "string") return null;

  const computeThickness = (s) => {
    if (!s || typeof s !== "number") return 3; // default thickness
    // Proportional rule: ~6% of avatar height, but at least 2px and rounded
    const t = Math.max(2, Math.round(s * 0.06));
    return t;
  };

  const thickness = computeThickness(sizePx);

  switch (decoration) {
    case "silver-ring":
      return `${thickness}px solid #C0C0C0`;
    case "gold-ring":
      return `${thickness}px solid #e5c13b`;
    case "diamond-overlay":
      return `${thickness}px solid #3bb4e5`;
    default:
      return null;
  }
};

// Derive decoration key from user object. Prefer membershipTier (authoritative),
// fall back to a stored avatarDecoration string for backward compatibility.
export const getDecorationFromUser = (user) => {
  if (!user) return null;
  // If membershipTier exists, map it to our decoration keys
  const tier = user.membershipTier || user.membership?.tier;
  if (tier && typeof tier === "string") {
    const t = tier.toLowerCase();
    if (t.includes("silver")) return "silver-ring";
    if (t.includes("gold")) return "gold-ring";
    if (t.includes("platinum")) return "diamond-overlay";
  }

  // Backwards compatibility: if avatarDecoration is already stored on the user
  if (user.avatarDecoration && typeof user.avatarDecoration === "string")
    return user.avatarDecoration;

  return null;
};
